import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

type VenueSwitchOverlayProps = {
  active: boolean;
  venueLabel: string;
};

/** Full-screen wipe while demo venue credentials and cached data reset. */
export function VenueSwitchOverlay({ active, venueLabel }: VenueSwitchOverlayProps) {
  const { t } = useTranslation();

  if (!active) return null;

  return (
    <div
      className={cn('oche-venue-switch fixed inset-0 z-[100] flex items-center justify-center')}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="oche-venue-switch__backdrop" aria-hidden />
      <div
        className="oche-venue-switch__wipe oche-liquid-wipe__wave oche-liquid-wipe__wave--front"
        aria-hidden
      />
      <div className="oche-venue-switch__panel oche-surface rounded-xl border border-[var(--color-line)] px-8 py-7 text-center shadow-2xl">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-[var(--color-muted)]">
          {t('venueSwitch.switching')}
        </p>
        <p className="mt-2 text-2xl font-semibold text-[var(--color-chalk)]">{venueLabel}</p>
        <p className="mt-1 text-sm text-[var(--color-muted)]">{t('venueSwitch.hint')}</p>
        <div className="oche-venue-switch__dots mt-5 flex justify-center gap-1.5" aria-hidden>
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
